import React from 'react';
import { DEFAULT_PAGE_SIZE, fetchProposals } from '@services/fmdc';
import { PROPOSAL_STATUS_FILTERS } from './fmdcUrl';

// The catalog proposals for one page of the URL's filters. Same shape as useCatalogItems.
export const useProposals = (filters, { enabled = true } = {}) => {
  const [proposals, setProposals] = React.useState(null);
  const [total, setTotal] = React.useState(0);
  const [error, setError] = React.useState(null);
  const [tick, setTick] = React.useState(0);

  const { proposalStatus, offset } = filters;

  React.useEffect(() => {
    if (!enabled) return undefined;
    const state = { isCanceled: false };
    const run = async () => {
      const result = await fetchProposals({
        status: proposalStatus === PROPOSAL_STATUS_FILTERS.ALL ? undefined : proposalStatus,
        limit: DEFAULT_PAGE_SIZE,
        offset,
      });
      if (state.isCanceled) return;
      if (result.error) {
        setError(result.error);
        setProposals((prev) => prev || []);
      } else {
        setError(null);
        setProposals(result.proposals);
        setTotal(result.total);
      }
    };
    run();
    return () => {
      state.isCanceled = true;
    };
  }, [enabled, proposalStatus, offset, tick]);

  const reload = React.useCallback(() => setTick((t) => t + 1), []);

  return { proposals, total, isLoading: proposals === null, error, reload };
};
